export class User {
    userId: string;
    accountId: string;
    userName: string;
    userPassword: string;
    roleId: string;
    createdOn: Date;
    createdBy: string;
    modifiedOn: Date;
    modifiedBy: string;
    statusCode: boolean;
}